/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 24.01.13, 13:55
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { HTMLTextVO } from "./HTMLTextVO";

export class HTMLTextCustomVO extends HTMLTextVO {
    public appendTextGlue: string = "\n";

}
